import { useState } from "react";
import "./FriendCard.css";

export default function FriendCard({ friend }) {
  const [upvotes, setUpvotes] = useState(friend.upvotes || 0);
  const [downvotes, setDownvotes] = useState(friend.downvotes || 0);

  const rating =
    upvotes + downvotes === 0
      ? friend.rating || 0
      : ((upvotes / (upvotes + downvotes)) * 5).toFixed(1);

  function handleVote(type) {
    const updatedFriend = { ...friend };

    if (type === "up") setUpvotes(upvotes + 1);
    if (type === "down") setDownvotes(downvotes + 1);

    // Save updated friend to JSON (localStorage for now)
    updatedFriend.upvotes = type === "up" ? upvotes + 1 : upvotes;
    updatedFriend.downvotes = type === "down" ? downvotes + 1 : downvotes;
    localStorage.setItem(`friend-${friend.id}`, JSON.stringify(updatedFriend));
  }

  return (
    <div className="friend-card">
      <img src={friend.photo} alt={friend.name} className="friend-photo" />
      <h2 className="friend-name">{friend.name}</h2>
      <p className="friend-details">
        {friend.gender} • {formatHeight(friend.height)} • $
        {friend.income.toLocaleString()}
      </p>
      <p className="friend-rating">⭐ {rating}</p>

      <div className="vote-buttons">
        <button onClick={() => handleVote("up")} className="vote-btn up">
          👍
        </button>
        <button onClick={() => handleVote("down")} className="vote-btn down">
          👎
        </button>
      </div>

      <div className="friend-tags">
        {friend.tags.map((tag) => (
          <span key={tag} className="tag">
            {tag}
          </span>
        ))}
      </div>
      <button className="wishlist-btn">Add to Wishlist 🛒</button>
    </div>
  );
}

function formatHeight(h) {
  const [feet, decimal] = h.toString().split(".");
  const inches = decimal ? parseInt(decimal) : 0;
  return `${feet}'${inches}"`;
}
